import { GET } from 'utils/requests.utils'

const BASE_URL = '/cabinet/affiliate_analyses'

export const fetchList = (data) => GET(`${BASE_URL}/overview`, data)

export const fetchProductDetails = (data) => GET(`${BASE_URL}/details`, data)
